import { render, staticRenderFns } from "./ConnectSettings.vue?vue&type=template&id=19bc933a&scoped=true&"
import script from "./ConnectSettings.vue?vue&type=script&lang=ts&"
export * from "./ConnectSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectSettings.vue?vue&type=style&index=0&id=19bc933a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bc933a",
  null
  
)

export default component.exports